export var countryISOMapping = [
    {threeLetter:"AFG", twoLetter: "AF"},
    {threeLetter:"ALA", twoLetter: "AX"},
    {threeLetter:"ALB", twoLetter: "AL"},
    {threeLetter:"DZA", twoLetter: "DZ"},
    {threeLetter:"ASM", twoLetter: "AS"},
    {threeLetter:"AND", twoLetter: "AD"},
    {threeLetter:"AGO", twoLetter: "AO"},
    {threeLetter:"AIA", twoLetter: "AI"},
    {threeLetter:"ATA", twoLetter: "AQ"},
    {threeLetter:"ATG", twoLetter: "AG"},
    {threeLetter:"ARG", twoLetter: "AR"},
    {threeLetter:"ARM", twoLetter: "AM"},
    {threeLetter:"ABW", twoLetter: "AW"},
    {threeLetter:"AUS", twoLetter: "AU"},
    {threeLetter:"AUT", twoLetter: "AT"},
    {threeLetter:"AZE", twoLetter: "AZ"},
    {threeLetter:"BHS", twoLetter: "BS"},
    {threeLetter:"BHR", twoLetter: "BH"},
    {threeLetter:"BGD", twoLetter: "BD"},
    {threeLetter:"BRB", twoLetter: "BB"},
    {threeLetter:"BLR", twoLetter: "BY"},
    {threeLetter:"BEL", twoLetter: "BE"},
    {threeLetter:"BLZ", twoLetter: "BZ"},
    {threeLetter:"BEN", twoLetter: "BJ"},
    {threeLetter:"BMU", twoLetter: "BM"},
    {threeLetter:"BTN", twoLetter: "BT"},
    {threeLetter:"BOL", twoLetter: "BO"},
    {threeLetter:"BIH", twoLetter: "BA"},
    {threeLetter:"BWA", twoLetter: "BW"},
    {threeLetter:"BVT", twoLetter: "BV"},
    {threeLetter:"BRA", twoLetter: "BR"},
    {threeLetter:"VGB", twoLetter: "VG"},
    {threeLetter:"IOT", twoLetter: "IO"},
    {threeLetter:"BRN", twoLetter: "BN"},
    {threeLetter:"BGR", twoLetter: "BG"},
    {threeLetter:"BFA", twoLetter: "BF"},
    {threeLetter:"BDI", twoLetter: "BI"},
    {threeLetter:"KHM", twoLetter: "KH"},
    {threeLetter:"CMR", twoLetter: "CM"},
    {threeLetter:"CAN", twoLetter: "CA"},
    {threeLetter:"CPV", twoLetter: "CV"},
    {threeLetter:"CYM", twoLetter: "KY"},
    {threeLetter:"CAF", twoLetter: "CF"},
    {threeLetter:"TCD", twoLetter: "TD"},
    {threeLetter:"CHL", twoLetter: "CL"},
    {threeLetter:"CHN", twoLetter: "CN"},
    {threeLetter:"HKG", twoLetter: "HK"},
    {threeLetter:"MAC", twoLetter: "MO"},
    {threeLetter:"CXR", twoLetter: "CX"},
    {threeLetter:"CCK", twoLetter: "CC"},
    {threeLetter:"COL", twoLetter: "CO"},
    {threeLetter:"COM", twoLetter: "KM"},
    {threeLetter:"COG", twoLetter: "CG"},
    {threeLetter:"COD", twoLetter: "CD"},
    {threeLetter:"COK", twoLetter: "CK"},
    {threeLetter:"CRI", twoLetter: "CR"},
    {threeLetter:"CIV", twoLetter: "CI"},
    {threeLetter:"HRV", twoLetter: "HR"},
    {threeLetter:"CUB", twoLetter: "CU"},
    {threeLetter:"CYP", twoLetter: "CY"},
    {threeLetter:"CZE", twoLetter: "CZ"},
    {threeLetter:"DNK", twoLetter: "DK"},
    {threeLetter:"DJI", twoLetter: "DJ"},
    {threeLetter:"DMA", twoLetter: "DM"},
    {threeLetter:"DOM", twoLetter: "DO"},
    {threeLetter:"ECU", twoLetter: "EC"},
    {threeLetter:"EGY", twoLetter: "EG"},
    {threeLetter:"SLV", twoLetter: "SV"},
    {threeLetter:"GNQ", twoLetter: "GQ"},
    {threeLetter:"ERI", twoLetter: "ER"},
    {threeLetter:"EST", twoLetter: "EE"},
    {threeLetter:"ETH", twoLetter: "ET"},
    {threeLetter:"FLK", twoLetter: "FK"},
    {threeLetter:"FRO", twoLetter: "FO"},
    {threeLetter:"FJI", twoLetter: "FJ"},
    {threeLetter:"FIN", twoLetter: "FI"},
    {threeLetter:"FRA", twoLetter: "FR"},
    {threeLetter:"GUF", twoLetter: "GF"},
    {threeLetter:"PYF", twoLetter: "PF"},
    {threeLetter:"ATF", twoLetter: "TF"},
    {threeLetter:"GAB", twoLetter: "GA"},
    {threeLetter:"GMB", twoLetter: "GM"},
    {threeLetter:"GEO", twoLetter: "GE"},
    {threeLetter:"DEU", twoLetter: "DE"},
    {threeLetter:"GHA", twoLetter: "GH"},
    {threeLetter:"GIB", twoLetter: "GI"},
    {threeLetter:"GRC", twoLetter: "GR"},
    {threeLetter:"GRL", twoLetter: "GL"},
    {threeLetter:"GRD", twoLetter: "GD"},
    {threeLetter:"GLP", twoLetter: "GP"},
    {threeLetter:"GUM", twoLetter: "GU"},
    {threeLetter:"GTM", twoLetter: "GT"},
    {threeLetter:"GGY", twoLetter: "GG"},
    {threeLetter:"GIN", twoLetter: "GN"},
    {threeLetter:"GNB", twoLetter: "GW"},
    {threeLetter:"GUY", twoLetter: "GY"},
    {threeLetter:"HTI", twoLetter: "HT"},
    {threeLetter:"HMD", twoLetter: "HM"},
    {threeLetter:"VAT", twoLetter: "VA"},
    {threeLetter:"HND", twoLetter: "HN"},
    {threeLetter:"HUN", twoLetter: "HU"},
    {threeLetter:"ISL", twoLetter: "IS"},
    {threeLetter:"IND", twoLetter: "IN"},
    {threeLetter:"IDN", twoLetter: "ID"},
    {threeLetter:"IRN", twoLetter: "IR"},
    {threeLetter:"IRQ", twoLetter: "IQ"},
    {threeLetter:"IRL", twoLetter: "IE"},
    {threeLetter:"IMN", twoLetter: "IM"},
    {threeLetter:"ISR", twoLetter: "IL"},
    {threeLetter:"ITA", twoLetter: "IT"},
    {threeLetter:"JAM", twoLetter: "JM"},
    {threeLetter:"JPN", twoLetter: "JP"},
    {threeLetter:"JEY", twoLetter: "JE"},
    {threeLetter:"JOR", twoLetter: "JO"},
    {threeLetter:"KAZ", twoLetter: "KZ"},
    {threeLetter:"KEN", twoLetter: "KE"},
    {threeLetter:"KIR", twoLetter: "KI"},
    {threeLetter:"PRK", twoLetter: "KP"},
    {threeLetter:"KOR", twoLetter: "KR"},
    {threeLetter:"KWT", twoLetter: "KW"},
    {threeLetter:"KGZ", twoLetter: "KG"},
    {threeLetter:"LAO", twoLetter: "LA"},
    {threeLetter:"LVA", twoLetter: "LV"},
    {threeLetter:"LBN", twoLetter: "LB"},
    {threeLetter:"LSO", twoLetter: "LS"},
    {threeLetter:"LBR", twoLetter: "LR"},
    {threeLetter:"LBY", twoLetter: "LY"},
    {threeLetter:"LIE", twoLetter: "LI"},
    {threeLetter:"LTU", twoLetter: "LT"},
    {threeLetter:"LUX", twoLetter: "LU"},
    {threeLetter:"MKD", twoLetter: "MK"},
    {threeLetter:"MDG", twoLetter: "MG"},
    {threeLetter:"MWI", twoLetter: "MW"},
    {threeLetter:"MYS", twoLetter: "MY"},
    {threeLetter:"MDV", twoLetter: "MV"},
    {threeLetter:"MLI", twoLetter: "ML"},
    {threeLetter:"MLT", twoLetter: "MT"},
    {threeLetter:"MHL", twoLetter: "MH"},
    {threeLetter:"MTQ", twoLetter: "MQ"},
    {threeLetter:"MRT", twoLetter: "MR"},
    {threeLetter:"MUS", twoLetter: "MU"},
    {threeLetter:"MYT", twoLetter: "YT"},
    {threeLetter:"MEX", twoLetter: "MX"},
    {threeLetter:"FSM", twoLetter: "FM"},
    {threeLetter:"MDA", twoLetter: "MD"},
    {threeLetter:"MCO", twoLetter: "MC"},
    {threeLetter:"MNG", twoLetter: "MN"},
    {threeLetter:"MNE", twoLetter: "ME"},
    {threeLetter:"MSR", twoLetter: "MS"},
    {threeLetter:"MAR", twoLetter: "MA"},
    {threeLetter:"MOZ", twoLetter: "MZ"},
    {threeLetter:"MMR", twoLetter: "MM"},
    {threeLetter:"NAM", twoLetter: "NA"},
    {threeLetter:"NRU", twoLetter: "NR"},
    {threeLetter:"NPL", twoLetter: "NP"},
    {threeLetter:"NLD", twoLetter: "NL"},
    {threeLetter:"ANT", twoLetter: "AN"},
    {threeLetter:"NCL", twoLetter: "NC"},
    {threeLetter:"NZL", twoLetter: "NZ"},
    {threeLetter:"NIC", twoLetter: "NI"},
    {threeLetter:"NER", twoLetter: "NE"},
    {threeLetter:"NGA", twoLetter: "NG"},
    {threeLetter:"NIU", twoLetter: "NU"},
    {threeLetter:"NFK", twoLetter: "NF"},
    {threeLetter:"MNP", twoLetter: "MP"},
    {threeLetter:"NOR", twoLetter: "NO"},
    {threeLetter:"OMN", twoLetter: "OM"},
    {threeLetter:"PAK", twoLetter: "PK"},
    {threeLetter:"PLW", twoLetter: "PW"},
    {threeLetter:"PSE", twoLetter: "PS"},
    {threeLetter:"PAN", twoLetter: "PA"},
    {threeLetter:"PNG", twoLetter: "PG"},
    {threeLetter:"PRY", twoLetter: "PY"},
    {threeLetter:"PER", twoLetter: "PE"},
    {threeLetter:"PHL", twoLetter: "PH"},
    {threeLetter:"PCN", twoLetter: "PN"},
    {threeLetter:"POL", twoLetter: "PL"},
    {threeLetter:"PRT", twoLetter: "PT"},
    {threeLetter:"PRI", twoLetter: "PR"},
    {threeLetter:"QAT", twoLetter: "QA"},
    {threeLetter:"REU", twoLetter: "RE"},
    {threeLetter:"ROU", twoLetter: "RO"},
    {threeLetter:"RUS", twoLetter: "RU"},
    {threeLetter:"RWA", twoLetter: "RW"},
    {threeLetter:"BLM", twoLetter: "BL"},
    {threeLetter:"SHN", twoLetter: "SH"},
    {threeLetter:"KNA", twoLetter: "KN"},
    {threeLetter:"LCA", twoLetter: "LC"},
    {threeLetter:"MAF", twoLetter: "MF"},
    {threeLetter:"SPM", twoLetter: "PM"},
    {threeLetter:"VCT", twoLetter: "VC"},
    {threeLetter:"WSM", twoLetter: "WS"},
    {threeLetter:"SMR", twoLetter: "SM"},
    {threeLetter:"STP", twoLetter: "ST"},
    {threeLetter:"SAU", twoLetter: "SA"},
    {threeLetter:"SEN", twoLetter: "SN"},
    {threeLetter:"SRB", twoLetter: "RS"},
    {threeLetter:"SYC", twoLetter: "SC"},
    {threeLetter:"SLE", twoLetter: "SL"},
    {threeLetter:"SGP", twoLetter: "SG"},
    {threeLetter:"SVK", twoLetter: "SK"},
    {threeLetter:"SVN", twoLetter: "SI"},
    {threeLetter:"SLB", twoLetter: "SB"},
    {threeLetter:"SOM", twoLetter: "SO"},
    {threeLetter:"ZAF", twoLetter: "ZA"},
    {threeLetter:"SGS", twoLetter: "GS"},
    {threeLetter:"SSD", twoLetter: "SS"},
    {threeLetter:"ESP", twoLetter: "ES"},
    {threeLetter:"LKA", twoLetter: "LK"},
    {threeLetter:"SDN", twoLetter: "SD"},
    {threeLetter:"SUR", twoLetter: "SR"},
    {threeLetter:"SJM", twoLetter: "SJ"},
    {threeLetter:"SWZ", twoLetter: "SZ"},
    {threeLetter:"SWE", twoLetter: "SE"},
    {threeLetter:"CHE", twoLetter: "CH"},
    {threeLetter:"SYR", twoLetter: "SY"},
    {threeLetter:"TWN", twoLetter: "TW"},
    {threeLetter:"TJK", twoLetter: "TJ"},
    {threeLetter:"TZA", twoLetter: "TZ"},
    {threeLetter:"THA", twoLetter: "TH"},
    {threeLetter:"TLS", twoLetter: "TL"},
    {threeLetter:"TGO", twoLetter: "TG"},
    {threeLetter:"TKL", twoLetter: "TK"},
    {threeLetter:"TON", twoLetter: "TO"},
    {threeLetter:"TTO", twoLetter: "TT"},
    {threeLetter:"TUN", twoLetter: "TN"},
    {threeLetter:"TUR", twoLetter: "TR"},
    {threeLetter:"TKM", twoLetter: "TM"},
    {threeLetter:"TCA", twoLetter: "TC"},
    {threeLetter:"TUV", twoLetter: "TV"},
    {threeLetter:"UGA", twoLetter: "UG"},
    {threeLetter:"UKR", twoLetter: "UA"},
    {threeLetter:"ARE", twoLetter: "AE"},
    {threeLetter:"GBR", twoLetter: "GB"},
    {threeLetter:"USA", twoLetter: "US"},
    {threeLetter:"UMI", twoLetter: "UM"},
    {threeLetter:"URY", twoLetter: "UY"},
    {threeLetter:"UZB", twoLetter: "UZ"},
    {threeLetter:"VUT", twoLetter: "VU"},
    {threeLetter:"VEN", twoLetter: "VE"},
    {threeLetter:"VNM", twoLetter: "VN"},
    {threeLetter:"VIR", twoLetter: "VI"},
    {threeLetter:"WLF", twoLetter: "WF"},
    {threeLetter:"ESH", twoLetter: "EH"},
    {threeLetter:"YEM", twoLetter: "YE"},
    {threeLetter:"ZMB", twoLetter: "ZM"},
    {threeLetter:"ZWE", twoLetter: "ZW"},
]

export const countryFind = (input) => {
    var output  = ""
    countryISOMapping.map((item)=>{
        if(item.threeLetter === input){
            output = item.twoLetter
        }
        return null
    })
    return output
}